import React from 'react';
import styled from 'styled-components';
import { Box, Heading, style, Text } from '@do/walrus';
import verifyEmailImage from '../assets/verify-email-sso.png';
import { SimpleHeader } from './Header';
import copy from '../copy';

const Container = styled.div`
  display: grid;
  width: 100%;
  height: calc(100vh - ${style.vars.space['10']});
  place-items: center;
  padding: ${style.vars.space['5']} 0;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  h4,
  p {
    text-align: center;
  }
`;

export const SSOVerifyPage = () => {
  return (
    <>
      <SimpleHeader />
      <Container>
        <Box maxWidth="800px" ml={3} mr={3} p={6}>
          <Content>
            <img
              src={verifyEmailImage}
              alt="Illustration of a scuba diver lounging on an inflatable raft in the ocean, sipping a drink through a straw while working on a laptop, with a seagull perched on their head and a buoy floating nearby."
            />
            <Box mt={4}>
              <Heading level="h2" weight="light">
                {copy.verify_email_sso.welcome}
              </Heading>
            </Box>
            <Box my={3}>
              <Heading level="h3">{copy.verify_email_sso.accept_email}</Heading>
            </Box>
            <Text>{copy.verify_email_sso.text1}</Text>
            <Text>{copy.verify_email_sso.text2}</Text>
            <Text>{copy.verify_email_sso.text3}</Text>
          </Content>
        </Box>
      </Container>
    </>
  );
};
